
import {validators} from 'vue-form-generator';

import {firstName, lastName} from '../field-templates/names/names';
import {email, additionalEmail, phone} from '../field-templates/contact-info/contactInfo';
import {address1, address2, city, state, zip, country} from '../field-templates/address/address';
import {poBoxNotInAddress, ampersandNotInAddress, lengthValidator} from '../field-templates/address/customValidations';
import {setCustomValidationProperties} from '../field-templates/customValidationHelpers';
import {buildField} from '../field-templates/fieldBuilder';

export default function shippingBaseFields(isReferralIdCustomer){
    let referralCustomerOverride = {}
    if (isReferralIdCustomer) {
        referralCustomerOverride = {"disabled": true, "type": "input", "inputType": "text"}
    }
    return {
        groups: [
            {
                styleClasses: "row",
                fields: [buildField(firstName), buildField(lastName)],
            },
            {
                styleClasses: "row",
                fields: [buildField(email), buildField(phone)]
            },
            {
                styleClasses: "row additional-email-row",
                fields: [buildField(additionalEmail)]
            },
            {
                styleClasses: "row",
                fields: [buildField(address1, {
                    validator: [validators.string,
                            setCustomValidationProperties(poBoxNotInAddress, "poBoxNotInAddress"),
                            setCustomValidationProperties(ampersandNotInAddress, "ampersandNotInAddress"),
                            setCustomValidationProperties(lengthValidator, "lengthValidator")]
                })]
            },
            {
                styleClasses: "row",
                fields: [buildField(address2, {
                    validator: [validators.string,
                            setCustomValidationProperties(poBoxNotInAddress, "poBoxNotInAddress"),
                            setCustomValidationProperties(ampersandNotInAddress, "ampersandNotInAddress"),
                            setCustomValidationProperties(lengthValidator, "lengthValidator")]
                })]
            },
            {
                styleClasses: "row",
                fields: [buildField(city), buildField(state), buildField(zip), buildField(country, referralCustomerOverride)]
            },
        ]
    }


}
